<template>
  <div class="verification-form-common-risk app-key-value__list">
    <div class="verification-cdd-form__questions-list">
      <h3 class="verification-cdd-form__title">
        {{ "verification-form-common-risk.title" | globalize }}
      </h3>

      <verification-form-question
        v-model="form.qus01"
        @input="former.setAttr('commonRisk.qus01', form.qus01)"
        :question-message="
          'verification-form-common-risk.qus-01' | globalize"
        :error-message="getFieldErrorMessage('form.qus01')"
        :disabled="isDisabled"
      />

      <verification-form-question
        v-model="form.qus02"
        @input="former.setAttr('commonRisk.qus02', form.qus02)"
        :question-message="
          'verification-form-common-risk.qus-02' | globalize"
        :error-message="getFieldErrorMessage('form.qus02')"
        :disabled="isDisabled"
      >
        <div
          v-if="country"
          class="verification-cdd-form__key-value-wrp app-key-value__row">
          <span class="app-key-value__key">
            {{ 'verification-form-common-risk.lbl-country' | globalize }}
          </span>
          <span class="app-key-value__value">
            {{ formatData(country) }}
          </span>
        </div>
      </verification-form-question>

      <verification-form-question
        v-model="form.qus03"
        @input="former.setAttr('commonRisk.qus03', form.qus03)"
        :question-message="
          'verification-form-common-risk.qus-03' | globalize"
        :error-message="getFieldErrorMessage('form.qus03')"
        :disabled="isDisabled"
      >
        <div
          v-if="!isEmpty(nationalities)"
          class="verification-cdd-form__key-value-wrp app-key-value__row">
          <span class="app-key-value__key">
            {{ 'verification-form-common-risk.lbl-nationalities' | globalize }}
          </span>
          <span class="app-key-value__value">
            {{ formatData(nationalities) }}
          </span>
        </div>
      </verification-form-question>
    </div>
  </div>
</template>

<script>
import VerificationFormQuestion from './VerificationFormQuestion'

import { VerificationCDDFormer } from '@/js/formers/VerificationCDDFormer'
import { UserRecord } from '@/js/records/entities/user.record'
import { required } from '@validators'
import _isEmpty from 'lodash/isEmpty'

import FormMixin from '@/vue/mixins/form.mixin'

export default {
  name: 'verification-form-common-risk',
  components: { VerificationFormQuestion },
  mixins: [ FormMixin ],
  props: {
    former: {
      type: VerificationCDDFormer,
      required: true,
    },
    userDetails: {
      type: UserRecord,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      form: {
        qus01: this.former.attrs.commonRisk.qus01,
        qus02: this.former.attrs.commonRisk.qus02,
        qus03: this.former.attrs.commonRisk.qus03,
      },
      isEmpty: _isEmpty,
    }
  },
  computed: {
    nationalities () {
      return this.userDetails.address.nationalities
    },
    country () {
      if (this.userDetails.address.structuredAddress) {
        return this.userDetails.address.structuredAddress.country
      }
      return null
    },
  },
  validations () {
    let form = {}
    Object.keys(this.form).forEach(key => { form[key] = { required } })

    return { form }
  },

  methods: {
    isArray (value) {
      return Array.isArray(value)
    },
    formatData (value) {
      if (!value) {
        return '-'
      } else if (this.isArray(value)) {
        return value.join(', ')
      } else {
        return value
      }
    },
  },
}
</script>
